/**
*
* MollieAlert
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Alert, Button } from 'react-bootstrap';
import messages from './messages.js';

const LowButton = styled(Button)`
  margin-top: -10px;
  margin-bottom: -10px;
`;

function getMessage(status, canReceivePayments) {
  switch (status) {
    case 'needs-data':
      return canReceivePayments ? messages.mollieNeedsDataWithPayments : messages.mollieNeedsDataNoPayments;
    case 'in-review':
      return canReceivePayments ? messages.mollieInReviewWithPayments : messages.mollieInReviewNoPayments;
    default:
      return `Unknown Mollie status: ${status}`;
  }
}

function MollieAlert(props) {
  const { mollie, className } = props;
  if (!mollie?.status) {
    return <Alert variant="danger" className={className}><FormattedMessage {...messages.mollieNoneInfo} /></Alert>;
  }
  const { status, canReceivePayments } = mollie;
  if (status === 'completed') {
    return null;
  }
  // eslint-disable-next-line no-underscore-dangle
  const link = mollie._links?.dashboard?.href || 'https://www.mollie.com/dashboard';
  return (
    <Alert variant="warning" className={className}>
      <FormattedMessage {...getMessage(status, canReceivePayments)} />
      {status === 'needs-data' && <LowButton variant="primary" className="ms-3 text-nowrap" href={link}><FormattedMessage {...messages.toMollie} /></LowButton>}
    </Alert>
  );
}

MollieAlert.propTypes = {
  mollie: PropTypes.object,
  className: PropTypes.string,
};

export default MollieAlert;
